import { CodeInputContainer, ResetCode, SingleInput } from './CodeInput.styled';
import Reset_Icon from '@assets/svg/match/reset.svg';
import { useEffect, useRef, useState } from 'react';

interface IProps {
  checkCode: (code: string) => void;
  reset?: boolean;
}

const CodeInput = (props: IProps) => {
  const [fieldOne, setFieldOne] = useState('');
  const [fieldTwo, setFieldTwo] = useState('');
  const [fieldThree, setFieldThree] = useState('');
  const [fieldFour, setFieldFour] = useState('');
  const [fieldFive, setFieldFive] = useState('');
  const keyInputDelay = useRef(false);

  useEffect(() => {
    document.getElementById('checkFieldOne').focus();
  }, []);

  useEffect(() => {
    if (fieldOne !== '' && fieldTwo !== '' && fieldThree !== '' && fieldFour !== '' && fieldFive !== '') {
      props.checkCode(`${fieldOne}${fieldTwo}${fieldThree}${fieldFour}${fieldFive}`);
      if (props.reset) {
        ResetFields();
      }
    }
  }, [fieldOne, fieldTwo, fieldThree, fieldFour, fieldFive, props.reset]);

  //console.log(window.visualViewport)

  const HandleInput = (e: any, field: string) => {
    if (e.target.value === '') {
      keyInputDelay.current = true;
      setTimeout(() => (keyInputDelay.current = false), 250);
      switch (field) {
        case '1':
          setFieldOne('');
          break;
        case '2':
          setFieldTwo('');
          document.getElementById('checkFieldOne').focus();
          break;
        case '3':
          setFieldThree('');
          document.getElementById('checkFieldTwo').focus();
          break;
        case '4':
          setFieldFour('');
          document.getElementById('checkFieldThree').focus();
          break;
        case '5':
          setFieldFive('');
          document.getElementById('checkFieldFour').focus();
          break;
      }
    } else if (/\d/.test(e.target.value?.charAt(e.target.value.length - 1))) {
      switch (field) {
        case '1':
          setFieldOne(e.target.value?.charAt(e.target.value.length - 1));
          document.getElementById('checkFieldTwo').focus();
          break;
        case '2':
          setFieldTwo(e.target.value?.charAt(e.target.value.length - 1));
          document.getElementById('checkFieldThree').focus();
          break;
        case '3':
          setFieldThree(e.target.value?.charAt(e.target.value.length - 1));
          document.getElementById('checkFieldFour').focus();
          break;
        case '4':
          setFieldFour(e.target.value?.charAt(e.target.value.length - 1));
          document.getElementById('checkFieldFive').focus();
          break;
        case '5':
          setFieldFive(e.target.value?.charAt(e.target.value.length - 1));
          break;
      }
    }
  };

  const handleBackSpace = (e: any, field: string) => {
    if (keyInputDelay.current) return;
    keyInputDelay.current = true;
    setTimeout(() => (keyInputDelay.current = false), 250);
    if (e.key === 'Backspace') {
      switch (field) {
        case '1':
          setFieldOne('');
          break;
        case '2':
          setFieldTwo('');
          document.getElementById('checkFieldOne').focus();
          break;
        case '3':
          setFieldThree('');
          document.getElementById('checkFieldTwo').focus();
          break;
        case '4':
          setFieldFour('');
          document.getElementById('checkFieldThree').focus();
          break;
        case '5':
          setFieldFive('');
          document.getElementById('checkFieldFour').focus();
          break;
      }
    }
  };

  const ResetFields = () => {
    setFieldOne('');
    setFieldTwo('');
    setFieldThree('');
    setFieldFour('');
    setFieldFive('');
    document.getElementById('checkFieldOne').focus();
  };

  return (
    <CodeInputContainer>
      <SingleInput
        type={'number'}
        id="checkFieldOne"
        autoComplete="off"
        value={fieldOne || ''}
        onChange={(e) => HandleInput(e, '1')}
        maxLength={2}
        onKeyUpCapture={(e) => handleBackSpace(e, '1')}
      />
      <SingleInput
        type={'number'}
        id="checkFieldTwo"
        autoComplete="off"
        value={fieldTwo || ''}
        onChange={(e) => HandleInput(e, '2')}
        maxLength={2}
        onKeyUpCapture={(e) => handleBackSpace(e, '2')}
      />
      <SingleInput
        type={'number'}
        id="checkFieldThree"
        autoComplete="off"
        value={fieldThree || ''}
        onChange={(e) => HandleInput(e, '3')}
        maxLength={2}
        onKeyUpCapture={(e) => handleBackSpace(e, '3')}
      />
      <SingleInput
        type={'number'}
        id="checkFieldFour"
        autoComplete="off"
        value={fieldFour || ''}
        onChange={(e) => HandleInput(e, '4')}
        maxLength={2}
        onKeyUpCapture={(e) => handleBackSpace(e, '4')}
      />
      <SingleInput
        type={'number'}
        id="checkFieldFive"
        autoComplete="off"
        value={fieldFive || ''}
        onChange={(e) => HandleInput(e, '5')}
        maxLength={2}
        onKeyUpCapture={(e) => handleBackSpace(e, '5')}
      />
      <ResetCode onClick={() => ResetFields()}>
        <Reset_Icon />
      </ResetCode>
    </CodeInputContainer>
  );
};

export default CodeInput;
